<script setup>
import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import Layout from '../../Components/Shared/Layout.vue';
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue';
import FarmForm from '../../Components/Forms/FarmForm.vue';

const farm = ref({
    name: '',
    size: '',
    lon: '',
    lat: '',
    area: [],
    area_unit: 'ha',
});

const farmAdded = () => {
    Inertia.visit('/portfolio');
};
</script>

<template>
    <Layout>
        <section class="w-full max-w-full min-w-0 px-3 py-5 mx-auto overflow-x-hidden sm:px-6 lg:px-10 xl:px-14">
            <header class="flex flex-col gap-2 mb-5 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <ButtonComponent
                        content="Volver al portafolio"
                        :icon="'arrow_back_ios'"
                        :link="'/portfolio'"
                        type="2"
                    />
                    <h1 class="text-2xl font-bold text-enriqueto_green sm:text-3xl">Crear Finca</h1>
                    <p class="mt-1 text-gray-700">
                        Ubica la finca, marca cada esquina de sus linderos y revisa el área antes de guardar.
                    </p>
                </div>
            </header>

            <div class="w-full max-w-full min-w-0 p-4 overflow-hidden bg-white border-2 border-light_green rounded-2xl sm:p-6">
                <FarmForm :farm="farm" :full-page="true" @added="farmAdded" />
            </div>
        </section>
    </Layout>
</template>
